export const NO_TITLE_LABEL = "(no title)";

export const getTitleOrNoTitle = (title: string | null | undefined): string => title?.trim() || NO_TITLE_LABEL;
